export const AVAILABILITY_TEXT = "Hotel results";
export const SHOP_TEXT = "Hotel details";
export const CUSTOMIZE_TEXT = "Customize";
export const BOOK_TEXT = "Book";
